import i18n from '~/i18n'
import { primary as theme } from '~/styles/themes'

import {
  abbreviateCurrency,
  formatCompareMetricLabel,
  formatStylesChart
} from '../../helpers'
import { CreateDataset } from '../types'
import { OptionsScale } from './types'

const axisID = 'y-newToBrandRevenue'

const settings = {
  label: i18n.t('rm:metrics.newToBrandRevenue'),
  formatData: (value: number) => abbreviateCurrency(value),
  color: theme.colors.hover,
  dataKey: 'newToBrandRevenueNumber' as keyof ReportHistoryCampaigns,
  order: 60
}

const dataset: CreateDataset = ({ data, isCompare = false }) => ({
  yAxisID: isCompare ? `${axisID}-compare` : axisID,
  type: 'line',
  label: formatCompareMetricLabel({ label: settings.label, isCompare }),
  data: data?.[settings.dataKey] || null,
  order: isCompare ? settings.order - 1 : settings.order,

  ...formatStylesChart({ color: settings.color, isCompare })
})

const optionsScale: OptionsScale = ({
  showScaleRuler = true,
  drawOnChartArea = true,
  position = 'left',
  isCompare = false
}) => ({
  [isCompare ? `${axisID}-compare` : axisID]: {
    display: showScaleRuler,
    grid: {
      drawOnChartArea
    },
    position,
    suggestedMin: 0,
    beginAtZero: true,
    ticks: {
      z: -1,
      color: settings.color,
      callback: settings.formatData
    }
  }
})

const newToBrandRevenuePreset = { axisID, dataset, optionsScale, settings }

export default newToBrandRevenuePreset
